import { createAsyncThunk } from '@reduxjs/toolkit';
import { VaultMeta } from "../state";
import { listVaults } from "../../utils/vault-storage";
import { syncMachineService } from "../../services/sync-state";

export const listVaultsThunk = createAsyncThunk<VaultMeta[]>(
  'vault/fetchVaultList',
  async () => {
    const storedVaults = listVaults();
    
    const vaultMetas = storedVaults.map(vault => ({
      info: {
        id: vault.vaultId,
        name: vault.name
      },
      syncState: {
        lastSyncDate: vault.lastSyncDate || new Date(0).toISOString(),
        lastChangeDate: vault.modifiedAt || vault.lastSyncDate || new Date(0).toISOString(),
        serverLastModified: vault.serverLastModified,
        syncId: vault.syncId
      },
      isSyncEnabled: vault.isSyncEnabled
    }));

    // Hydrate a state machine for each vault based on its stored metadata.
    // Machines start in InitialisingState; this transitions them to their
    // correct initial state before any sync operations can proceed.
    for (const vault of storedVaults) {
      const machine = syncMachineService.getOrCreate(vault.vaultId);

      if (!vault.isSyncEnabled || !vault.syncId) {
        // Never been synced, or sync was disabled — local-only
        machine.initialiseLocalOnly(vault.vaultId);
        continue;
      }

      const lastSyncDate = vault.lastSyncDate || new Date(0).toISOString();
      const serverLastModified = vault.serverLastModified || '';
      const localChangedAt = vault.modifiedAt || lastSyncDate;

      const context = {
        localId: vault.vaultId,
        serverId: vault.syncId,
        lastSyncDate,
        serverLastModified,
      };

      const isDirty =
        vault.modifiedAt != null &&
        vault.lastSyncDate != null &&
        new Date(vault.modifiedAt) > new Date(vault.lastSyncDate);

      if (isDirty) {
        machine.initialiseDirty({ ...context, localChangedAt });
      } else {
        machine.initialiseSyncEnabled(context);
      }
    }

    return vaultMetas;
  }
);